var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPassengerIcon = function SvgPassengerIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 500 500",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.035 290.059C329.833 290.059 395.064 224.827 395.064 145.029C395.064 65.2311 329.833 0 250.035 0C170.237 0 105.007 65.2311 105.007 145.029C105.007 224.827 170.238 290.059 250.035 290.059Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M498.931 405.952C495.131 396.451 490.065 387.585 484.365 379.352C455.233 336.286 410.268 307.787 359.603 300.821C353.27 300.188 346.304 301.453 341.237 305.254C314.638 324.887 282.972 335.019 250.039 335.019C217.106 335.019 185.441 324.887 158.841 305.254C153.774 301.453 146.808 299.554 140.475 300.821C89.8101 307.787 44.2118 336.286 15.7129 379.352C10.0131 387.585 4.94613 397.085 1.14708 405.952C-0.752445 409.752 -0.119675 414.185 1.77985 417.985C6.84686 426.851 13.1794 435.718 18.8792 443.318C27.7453 455.351 37.2453 466.117 48.0121 476.25C56.8781 485.116 67.011 493.349 77.145 501.582C127.176 538.949 187.342 558.58 249.406 558.58C311.471 558.58 371.637 538.947 421.668 501.582C431.801 493.983 441.933 485.116 450.801 476.25C460.934 466.117 471.066 455.35 479.934 443.318C486.266 435.084 491.967 426.851 497.033 417.985C500.198 414.185 500.831 409.751 498.931 405.952Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPassengerIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/passenger-icon.9cf0b097.svg";
export { ForwardRef as ReactComponent };